'use client';
import React, { useEffect, useRef } from 'react'
import { RichText as RichTextConverter } from "@payloadcms/richtext-lexical/react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function HeadingBlock({ title, description, isRow = false }: any) {
  const renderRichTextAsHTML = (richText: any) => {
    if (!richText?.root?.children?.[0]?.children) return '';

    const elements = richText.root.children[0].children.map((textNode: any, index: number) => {
      if (textNode.format === 1) {
        return <span className='text-xl-bold md:text-2xl-bold xl:text-3xl-bold text-neutral-900 ' key={index}>{textNode.text}</span>;
      } else {
        return <span className='text-xl-regular md:text-2xl-regular md:max-w-[90%] xl:text-3xl-regular text-neutral-900 ' key={index}>{textNode.text}</span>;
      }
    });

    return <>{elements}</>;
  }
  
  const renderTitle = () => {
    if (typeof title === 'string') {
      if (title.includes('<') && title.includes('>')) {
        return <span className='text-xl-regular md:text-2xl-regular xl:text-3xl-regular text-neutral-900 ' dangerouslySetInnerHTML={{ __html: title }} />;
      }
      return title;
    } else {
      return renderRichTextAsHTML(title);
    }
  }

  const renderDescription = () => {
    if (typeof description === 'string') {
      if (description.includes('<') && description.includes('>')) {
        return <span dangerouslySetInnerHTML={{ __html: description }} />;
      }
      return description;
    } else {
      return <RichTextConverter
          className=""
          data={description as any}
        />
    }
  }
  
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  
  useEffect(() => {
  if (isInView) {
    controls.start({ 
      backgroundSize: "100% 50%",
      backgroundPosition: "left top",
      transition: { duration: 1.5, ease: "easeInOut" } 
    });
  }
}, [isInView, controls]);

  return (
    <div className={`grid ${isRow ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'} gap-16 w-full heading-block`}>
      <div>
        <motion.h2
          ref={ref}
          className="text-xl-regular md:text-2xl-regular md:max-w-[90%] xl:text-3xl-regular text-neutral-900 bg-no-repeat bg-top"
          style={{
            display: 'inline',
            boxDecorationBreak: 'clone',
            WebkitBoxDecorationBreak: 'clone',
            backgroundImage: 'linear-gradient(to bottom, #F1F6F3, #F1F6F3)'
          }}
          initial={{ backgroundSize: "0% 50%", backgroundPosition: "right top" }}
          animate={controls}
        >
          {renderTitle()}
        </motion.h2>
      </div>
      {description && 
        <div className='text-neutral-900'>{renderDescription()}</div>
      }
    </div>
  )
}